var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"softwareComponentTypes",attrs:{"title":_vm.$t('softwareComponent.softwareComponent'),"icon":"hotel"}},[_c('SoftwareComponentFullList',{ref:"softwareComponentFullList"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }